import React, { useEffect, useRef, useState } from "react";

function NumberAnimation({ value, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Start animation each time component enters viewport
          let startTimestamp = null;
          const end = value;
          console.log("end ", end)

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            let value = progress * end;

            // check if value is an integer
            if (Number.isInteger(end)) {              
              setCount(Math.floor(value));
            } else {
              // keep one decimal if not integer
              setCount(Math.floor(value * 10) / 10);
            }

            if (progress < 1) requestAnimationFrame(step);




            // setCount(Math.floor(progress * end));
            // if (progress < 1) requestAnimationFrame(step);
          };

          requestAnimationFrame(step);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [value, duration]);

  return (
    <span
      ref={ref}
      style={{
        display: "inline-block",
        minHeight: "1em",
      }}
    >
      {count}
    </span>
  );
}

function Productivity() {
  return (
    <section className="spl ovh position-relative ps text-center"  >
      <div className="container">
        <div className="row">
          <div className="col-sm-4">
            <div className="round_content">
              <h3>
                <NumberAnimation value={2} duration={100} />x
              </h3>
              <p>STRESS RESILIENCE</p>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="round_content">
              <h3>
                <NumberAnimation value={10} duration={300} />x
              </h3>
              <p>PRODUCTIVITY</p>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="round_content">
              <h3>
                <NumberAnimation value={1.5} duration={300} />x
              </h3>
              <p>HEALTH SPAN</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Productivity;
